<script setup lang="ts">
    import { computed } from 'vue';
    import type { ValidationRule } from 'vuetify';

    const props = defineProps<{
        modelValue?: string;
        label?: string;
        fieldProps?: object;
        counter?: number;
        required?: boolean;
        rows?: number;
        disabled?: boolean;
        readonly?: boolean;
        rules?: ValidationRule[];
        autoGrow?: boolean;
        showCharCount?: boolean;
        maxCharCount?: number;
        maxlength?: number;
        errorMessages?: string | string[];
        clearable?: boolean;
    }>();

    const emit = defineEmits<{
        (e: 'update:modelValue', v: string): void;
        (e: 'blur', event: FocusEvent): void;
    }>();

    const innerValue = computed({
        get: () => props.modelValue,
        set: (val: string | undefined) => emit('update:modelValue', val ?? ''),
    });
    const computedLabel = computed(() => {
        if (props.required) {
            return `${props.label} *`;
        }
        return props.label;
    });

    const charCount = computed(() => {
        return props.modelValue?.length || 0;
    });
</script>

<template>
    <div>
        <v-textarea
            v-model="innerValue"
            v-bind="props.fieldProps"
            :label="computedLabel"
            variant="outlined"
            :counter="props.counter"
            rounded
            :rows="props.rows"
            :auto-grow="props.autoGrow"
            :disabled="props.disabled"
            :readonly="props.readonly"
            :rules="props.rules"
            :error-messages="props.errorMessages"
            :maxlength="props.maxlength"
            :clearable="props.clearable"
            @blur="emit('blur', $event)"
        />
        <div v-if="props.showCharCount" class="text-right text-caption mt-1">
            {{ charCount }}/{{ props.maxCharCount }}
        </div>
    </div>
</template>
